/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/button-has-type */

import React, {Component} from 'react';

import Link from './Link';
import {cx} from '../util';

export default class Button extends Component {
  render() {
    const {
      children,
      disabled,
      loading,
      onClick,
      className,
      secondary,
      grey,
      uppercase,
      rounded,
      outline,
      href,
      asLink,
      full,
      target,
      type,
      viewEvent,
      style,
    } = this.props;

    const classes = cx(
      'inline-flex items-center justify-center',
      'border rounded-md cursor-pointer',
      'leading-4 font-medium py-2.5 px-6',
      'min-w-[120px]',
      'whitespace-nowrap text-base text-center no-underline',
      'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500',
      {
        'border-transparent shadow-sm text-white bg-indigo-600 hover:bg-indigo-700': !secondary && !grey && !outline,
        'border-gray-300 shadow-sm text-gray-700 bg-white hover:bg-gray-50': secondary,
        'border-transparent bg-gray-100 text-black shadow-none hover:bg-gray-200': grey,
        'border-gray-200 text-gray-500 bg-transparent shadow-none hover:brightness-90': outline,
        'uppercase tracking-widest text-sm': uppercase,
        'rounded-full': rounded,
        'w-full': full,
        'opacity-50 pointer-events-none': disabled,
      },
      className,
    );

    const clickEvent = (e) => {
      if (viewEvent) viewEvent();
      if (onClick) onClick(e);
    };

    if (asLink && href) {
      return (
        <Link
          className={classes}
          onClick={clickEvent}
          href={href}
          disabled={disabled || loading}
          target={target}
          style={style}
        >
          <>
            {children}
            {loading && <div className="relative size-8 mx-auto my-6 animate-spin before:content-[''] before:absolute before:inset-0 before:rounded-full before:border-2 before:border-white/40 before:border-t-white/80" />}
          </>
        </Link>
      );
    }

    if (href) {
      return (
        <a
          className={classes}
          onClick={clickEvent}
          href={href}
          target={target}
          disabled={disabled || loading}
          style={style}
        >
          {children}
          {loading && <div className="relative size-8 mx-auto my-6 animate-spin before:content-[''] before:absolute before:inset-0 before:rounded-full before:border-2 before:border-white/40 before:border-t-white/80" />}
        </a>
      );
    }

    return (
      <button
        type={type}
        className={classes}
        onClick={clickEvent}
        disabled={disabled || loading}
        style={style}
      >
        {children}
        {loading && <div className="relative size-8 mx-auto my-6 animate-spin before:content-[''] before:absolute before:inset-0 before:rounded-full before:border-2 before:border-white/40 before:border-t-white/80" />}
      </button>
    );
  }
}

Button.defaultProps = {
  disabled: false,
  loading: false,
  onClick: undefined,
  className: null,
  secondary: false,
  grey: false,
  uppercase: false,
  rounded: false,
  outline: false,
  href: undefined,
  asLink: false,
  full: false,
  target: null,
  viewEvent: undefined,
  type: 'button',
  style: undefined,
};

